var map = {
	"./CommentCount.importable": [
		413,
		331,
		327,
		413
	],
	"./EditionDropdown.importable": [
		9623,
		331,
		790
	],
	"./GetMatchStats.importable": [
		433,
		331,
		327,
		433
	],
	"./InstagramBlockComponent.importable": [
		5252,
		331,
		624,
		252
	],
	"./SubNav.importable": [
		6348,
		331,
		348
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8602;
module.exports = webpackAsyncContext;